/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';

import BulmaContainer from 'react-bulma-components/lib/components/container';
import BulmaSection from 'react-bulma-components/lib/components/section';

import { linkResolver } from '../../util/linkResolver';

import { Heading, Modal, BreadcrumbNav, Button, LazyLink } from '../atoms';

import {
  styledHeading,
  styledSubheading,
  styledLightRichText,
  styledDarkRichText,
  StyledDocument,
  styledModal,
  styleSection,
  StyledModalContent,
  StyledModalHeader,
  styledModalTitle,
  StyledCloseBtn,
  StyledModalCopy,
  StyledButtonContainer,
  StyledModalTextLink,
} from './DocumentContentStyles';

const renderHeading = (text, atts) => (
  <Heading {...atts} css={atts.css}>
    {text.text}
  </Heading>
);

const DocumentContent = ({ input }) => {
  const {
    text_color,
    heading,
    heading_color,
    subheading,
    subheading_color,
    background_image,
    background_color,
    document_content_text,
    modal_link_title,
    modal_link_url,
    modal_ref_title,
    modal_ref_copy,
    modal_primary_button_text,
    modal_secondary_button_text,
    section_id,
  } = input.primary;

  const [currentDownloadLink, setCurrentDownloadLink] = useState(null);
  const [modalIsShowing, setModalIsShowing] = useState(false);

  return (
    <span css={styleSection}>
      <BulmaSection
        style={{
          backgroundColor: background_color || '#fff',
          backgroundImage: background_image && background_image.url ? `url(${background_image.url})` : null,
        }}
        id={section_id}
      >
        <BulmaContainer>
          <StyledDocument>
            <BreadcrumbNav data-testid="breadcrumb" breadcrumbs={input.fields} />
            {heading && heading[0].text ? (
              <Heading
                style={heading_color ? { color: heading_color } : null}
                css={styledHeading}
                className={text_color === 'light' ? 'white' : 'darkblue'}
                renderAs="h1"
                data-testid="heading"
              >
                {heading[0].text}
              </Heading>
            ) : null}
            {subheading && subheading[0].text ? (
              <Heading
                style={subheading_color ? { color: subheading_color } : null}
                css={styledSubheading}
                className={text_color === 'light' ? 'medium white' : 'medium darkgrey'}
                subtitle
                renderAs="p"
                data-testid="subheading"
              >
                {subheading[0].text}
              </Heading>
            ) : null}
            <div data-testid="document_text" css={text_color === 'light' ? styledLightRichText : styledDarkRichText}>
              <RichText render={document_content_text} linkResolver={linkResolver} />
            </div>
          </StyledDocument>

          <StyledModalTextLink>
            <a
              role="button"
              tabIndex="0"
              onClick={() => {
                setCurrentDownloadLink(modal_link_url.url);
                setModalIsShowing(true);
              }}
              onKeyPress={() => setModalIsShowing(true)}
            >
              {modal_link_title}
            </a>
          </StyledModalTextLink>

          {/* Modal */}
          <Modal
            show={modalIsShowing}
            onClose={() => {
              setCurrentDownloadLink(null);
              setModalIsShowing(false);
            }}
            css={styledModal}
            closeOnBlur
            showClose={false}
          >
            <StyledModalContent>
              <StyledModalHeader>
                {modal_ref_title &&
                  modal_ref_title[0].text &&
                  renderHeading(modal_ref_title[0], {
                    renderAs: 'h5',
                    className: 'h5 darkblue',
                    css: styledModalTitle,
                  })}

                <StyledCloseBtn
                  onClick={() => {
                    setCurrentDownloadLink(null);
                    setModalIsShowing(false);
                  }}
                />
              </StyledModalHeader>
              <StyledModalCopy>
                <RichText render={modal_ref_copy} linkResolver={linkResolver} />
              </StyledModalCopy>
              <StyledButtonContainer>
                <LazyLink
                  className={text_color === 'light' ? 'button-link is-white' : 'button-link is-primary'}
                  url={currentDownloadLink}
                >
                  {modal_primary_button_text}
                </LazyLink>
                <Button
                  color={text_color === 'light' ? 'white' : 'primary'}
                  outlined
                  renderAs="a"
                  onClick={() => {
                    setCurrentDownloadLink(null);
                    setModalIsShowing(false);
                  }}
                >
                  {modal_secondary_button_text}
                </Button>
              </StyledButtonContainer>
            </StyledModalContent>
          </Modal>
        </BulmaContainer>
      </BulmaSection>
    </span>
  );
};

export default DocumentContent;

DocumentContent.propTypes = {
  input: PropTypes.object.isRequired,
};
